<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch06">
<div class="chapterHead">
<h2 class="chapterTitle2"><span class="xrefInternal"><a href="#/contents#ch_06"><span class="bold">C<span class="smallCaps">HUCK</span> B<span class="smallCaps">ERRY</span></span></a></span><span class="footnoteRef"><span href="#/footnote#footnote6" id="fn6" title="Link target outside of Sample"><sup>*</sup></span></span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText">S<span class="smallCaps">INCE THE TIME THEY HAD ONE OF THEIR FIRST HITS WITH</span> “R<span class="smallCaps">OLL OVER</span> B<span class="smallCaps">EETHOVEN,”</span> I’<span class="smallCaps">VE ALWAYS FELT VERY CLOSE TO THE</span> B<span class="smallCaps">EATLES.</span> I <span class="smallCaps">FEEL AS IF</span> I <span class="smallCaps">LOST A LITTLE PART OF MYSELF WHEN</span> J<span class="smallCaps">OHN DIED.</span></p>
<p class="image1"><img alt="image" src="28.jpg"/></p>
<p class="caption">Eric’s drawing for Grandma and Grandpa.</p>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch06.vue?42b512b4